import React, { useState } from 'react';
import { InstagramIcon, ArrowUpRightIcon } from 'lucide-react';
const PROFILE_URL = 'https://www.instagram.com/honduransinla/';
const EMBED_URL = 'https://www.instagram.com/honduransinla/embed/';
export function InstagramFeed() {
  const [loaded, setLoaded] = useState(false);
  return <section id="instagram" className="overflow-hidden bg-flamingo py-20 text-sand md:py-28" data-id="element-157" data-mp="22qd81k2ibj5h">
      <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-12 px-5 md:px-8 lg:grid-cols-12" data-id="element-158" data-mp="2zg2x89s4b8rc">
        <div className="min-w-0 lg:col-span-5" data-id="element-159" data-mp="2uht19wykk44o">
          <p className="font-script text-4xl text-sun" data-id="element-160" data-mp="2uex4ibygjlht">Síguenos</p>
          <h2 className="mt-1 font-display text-[2.6rem] uppercase leading-[0.9] [overflow-wrap:anywhere] sm:text-6xl md:text-7xl xl:text-8xl" data-id="element-161" data-mp="2qdlalu8jwe3t">
            @honduransinla
          </h2>
          <p className="mt-6 max-w-md text-lg text-sand/90" data-id="element-162" data-mp="1f10widjpiz00">
            Events, business spotlights, and everyday Catracho pride across Los Angeles — straight from our feed.
          </p>
          <a href={PROFILE_URL} target="_blank" rel="noopener noreferrer" className="group mt-8 inline-flex items-center gap-2 rounded-full bg-sand px-7 py-4 font-bold text-ink transition-[transform,background-color] duration-150 ease-out hover:bg-sun active:scale-[0.97]" data-id="element-163" data-mp="2xup7t8bqxrqs">
            <InstagramIcon size={18} data-id="element-164" data-mp="2trislb6noq86" />
            Follow on Instagram
            <ArrowUpRightIcon size={16} className="transition-transform duration-150 ease-out group-hover:-translate-y-0.5 group-hover:translate-x-0.5" data-id="element-165" data-mp="2f3ehotduhizy" />
          </a>
        </div>

        <div className="lg:col-span-7" data-id="element-166" data-mp="265cc00j6226c">
          <div className="relative mx-auto w-full max-w-xl overflow-hidden rounded-[2rem] bg-sand" data-id="element-167" data-mp="2a5crloi04jez">
            {!loaded && <div className="absolute inset-0 grid grid-cols-3 gap-1 p-4 pt-24" aria-hidden="true" data-id="element-168" data-mp="1w5br4a5nfe01">
                {Array.from({
              length: 9
            }).map((_, i) => <div key={i} className="aspect-square animate-pulse rounded-lg bg-dune" data-id="element-169" data-mp="6og3g5xvci43" data-mpi={i} />)}
              </div>}
            <iframe src={EMBED_URL} title="Hondurans in LA on Instagram" loading="lazy" onLoad={() => setLoaded(true)} className={`relative block h-[640px] w-full border-0 transition-opacity duration-200 ${loaded ? 'opacity-100' : 'opacity-0'}`} data-id="element-170" data-mp="1wommn4ilqr5" />
          </div>
        </div>
      </div>
    </section>;
}